var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptionOfGoods"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.LoadingReport.Loading_Quantity'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Loading_Quantity'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.lmediaGates,"otherData":{
          mediaName: '工厂大门',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaGates',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Packed'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.lmediaPacked,"otherData":{
          mediaName: '大货箱堆',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaPacked',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Unpacked'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.lmediaUnpacked,"otherData":{
          mediaName: '未入箱成品',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaUnpacked',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Semi_finished'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.lmediaSemi,"otherData":{
          mediaName: '半成品',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaSemi',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table1",attrs:{"columns":_vm.columns,"dataSource":_vm.data,"bordered":"","pagination":false,"rowKey":"id"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }